export const isBrowser = (): boolean =>
  typeof window !== 'undefined' && typeof document !== 'undefined';

// Storage existence is checked directly because Next.js SSR environments sometimes
// polyfill `window` and `document` via jsdom but do not provide Web Storage. Trusting
// `isBrowser()` alone for storage access caused a build-time throw — these guards
// fail closed without surprising consumers.
export const hasSessionStorage = (): boolean => typeof sessionStorage !== 'undefined';
export const hasLocalStorage = (): boolean => typeof localStorage !== 'undefined';
